import { memo } from 'react';

import { DefaultBanner } from '~/components/AssetModalV2/Header/components/DefaultBanner';
import { LoggedInBanner } from '~/components/AssetModalV2/Header/components/LoggedInBanner';
import { usePublicShareWorkspaceAccess } from '~/components/PublicShareWorkspaceAccessProvider';

export const PublicBanner = memo(() => {
  const { viewerIsMemberOfPublicWorkspace } = usePublicShareWorkspaceAccess();

  return (
    <div className="flex w-screen shrink-0 items-center" data-testid="PUBLIC_BANNER">
      {viewerIsMemberOfPublicWorkspace ? <LoggedInBanner /> : <DefaultBanner />}
    </div>
  );
});

PublicBanner.displayName = 'PublicBanner';
